// A toadstool: a pale stem under a domed red cap with white speckles. Ported
// 1:1 from age-of-mcp's classic mushroom.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.013, 0.017, 0.046, 5),
      color: "#f1e6c8", position: [0, 0.023, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.039, 0),
      color: "#b73a3a", position: [0, 0.052, 0], scale: [1, 0.62, 1] },
    { geometry: new THREE.IcosahedronGeometry(0.008, 0),
      color: "#ffffff", position: [0.016, 0.062, 0.011] },
    { geometry: new THREE.IcosahedronGeometry(0.007, 0),
      color: "#ffffff", position: [-0.013, 0.057, -0.013] },
  ];
}

export const mushroom = defineModel({
  id: "mushroom",
  batchId: "standard",
  name: "Mushroom",
  tags: ["scenery","mushroom","low-poly","age-of-mcp","classic"],
  summary: "Low-poly mushroom.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  parts: () => partsFor(),
  animations: [],
});
